import { fetchCentre, fetchCourse, fetchRoom, fetchUser } from 'api'

const PAGE_SIZE = 500

const unwrapResults = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : []

export const fetchAllCentres = async () => {
  const data = await fetchCentre({ queries: { limit: PAGE_SIZE } })
  return unwrapResults(data)
    .filter((c) => c && c.name)
    .map((c) => ({ uuid: c.uuid, name: c.name }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const fetchAllCourses = async () => {
  const data = await fetchCourse({ queries: { limit: PAGE_SIZE } })
  return unwrapResults(data)
    .filter((c) => c && c.name)
    .map((c) => ({ uuid: c.uuid, name: c.name }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const fetchAllTeachers = async () => {
  const data = await fetchUser({ queries: { limit: PAGE_SIZE } }, 'teacher')
  return unwrapResults(data)
    .map((t) => {
      const user = t?.user || {}
      const first = user.first_name || ''
      const last = user.last_name || ''
      const full = (t.full_name || `${first} ${last}`).trim()
      return {
        uuid: t.uuid || user.uuid,
        full_name: full || user.email_address || user.phone_number || 'Unnamed',
        phone_number: user.phone_number || ''
      }
    })
    .filter((t) => t.phone_number)
    .sort((a, b) => a.full_name.localeCompare(b.full_name))
}

export const fetchAllRooms = async () => {
  const data = await fetchRoom({ queries: { limit: PAGE_SIZE } })
  return unwrapResults(data)
    .filter((r) => r && r.name && !r.deleted)
    .map((r) => ({
      uuid: r.uuid,
      name: r.name,
      centre_uuid: r.centre?.uuid || r.centre_uuid || r.centre || null
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
}
